/**
 * Wave 8 — Soft-filter EOIP cards / EM rows for EPC commercial surfaces.
 */
import type { EoipIntelligenceCard } from '@/services/eoip.service';
import type { EnterpriseMemoryRow } from '@/services/enterpriseMemory.service';

const COMMERCIAL_RE =
  /epc_|tender|award|mobiliz|bid.?decision|prequal|proposal|submission|commercial/i;

export function isCommercialEoipCard(card: EoipIntelligenceCard): boolean {
  const blob = `${card.kind || ''} ${card.domain || ''} ${card.headline || ''} ${card.why || ''}`;
  return COMMERCIAL_RE.test(blob) || /projects|commercial|epc/i.test(card.domain || '');
}

export function filterCommercialEoipCards(
  cards: EoipIntelligenceCard[] | undefined,
  limit = 8
): EoipIntelligenceCard[] {
  const all = cards || [];
  const filtered = all.filter(isCommercialEoipCard);
  const source = filtered.length ? filtered : all;
  return source.slice(0, limit);
}

export function filterCommercialMemories(
  rows: EnterpriseMemoryRow[] | undefined,
  limit = 5
): EnterpriseMemoryRow[] {
  const all = rows || [];
  const commercial = all.filter(
    (r) =>
      /commercial|contract|epc|tender/i.test(r.domain || '') ||
      COMMERCIAL_RE.test(`${r.title || ''} ${r.summary || ''}`)
  );
  return (commercial.length ? commercial : all).slice(0, limit);
}
